export const range = (value, props) => {
  if (
    Number(props.amount) < Number(props.min) ||
    Number(props.amount) > Number(props.max)
  ) {
    return `Der Betrag muss zwischen ${props.min}€ und ${props.max}€ liegen.`;
  }
};



// WEBPACK FOOTER //
// ./src/Validation/DonationFormValidators.js